module.exports = __webpack_public_path__ + "static/img/kddi_group_logo.52d2303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/kddi_group_logo.jpg
// module id = yMwZ
// module chunks = 0